import React from "react";

import { Select } from "clearsense-ui/components";
import convertToSelectOptions from "utils/convertToSelectOptions";

const Filters = ({
  domains,
  contexts,
  cdes,
  ruleTypes,
  isFilterLoading,
  setFilters,
}) => {
  const onFilterChange = (selectedOption, filterType) =>
    setFilters(prev => ({
      ...prev,
      [filterType]: selectedOption?.value ?? selectedOption,
    }));

  return (
    <div className="grid grid-cols-2 p-8 gap-4 gap-x-8">
      <Select
        isClearable
        placeholder="Select a Domain"
        label="Domain"
        size="small"
        onChange={option => onFilterChange(option, "domain")}
        options={convertToSelectOptions(domains, { isSort: true })}
        isLoading={isFilterLoading}
      />
      <Select
        isClearable
        placeholder="Select a Context"
        label="Context"
        size="small"
        onChange={option => onFilterChange(option, "context")}
        options={convertToSelectOptions(contexts, { isSort: true })}
        isLoading={isFilterLoading}
      />
      <Select
        isClearable
        placeholder="Select a CDE"
        label="Critical Data Element"
        size="small"
        onChange={option => onFilterChange(option, "critical_data_element")}
        options={convertToSelectOptions(cdes, { isSort: true })}
        isLoading={isFilterLoading}
      />
      <Select
        isClearable
        placeholder="Select a Business Rule Type"
        label="Business Rule Type"
        size="small"
        onChange={option => onFilterChange(option, "business_rule_type")}
        options={convertToSelectOptions(ruleTypes, { isSort: true })}
        isLoading={isFilterLoading}
      />
    </div>
  );
};

export default Filters;
